import { BlockLink } from 'BlockLink';
import { memo } from 'react';
import { type ButtonConfig } from '../StudentDashboardSidebar.types';

function LogoBoxButtonsComponent({
    buttons,
    handleButtonClick,
}: {
    buttons: ButtonConfig[];
    handleButtonClick: (button: ButtonConfig) => void;
}) {
    return (
        <div className="mt-[14px]">
            {buttons.map(button => (
                <BlockLink
                    key={button.id}
                    onPress={() => handleButtonClick(button)}
                    anchorIcon="right-arrow"
                    className="text-start"
                >
                    {button.text}
                </BlockLink>
            ))}
        </div>
    );
}

export const LogoBoxButtons = memo(LogoBoxButtonsComponent) as typeof LogoBoxButtonsComponent;
